import React, { useState } from "react";
import OrdersTAb from "./components/OrdersTab";

import axios from "axios";
import SplashScreen from "../../components/loader/SplashScreen/SplashScreen";
import { useQuery } from "@tanstack/react-query";
import Constants from "../../utils/Constants";
import { DecryptData } from "../../utils/Cipher";

const Orders = () => {
  const [loader, Setloader] = useState(false);

  //user data which is logged in.
  const userdata = DecryptData();

  const OrdersApi = () => {
    return axios({
      method: "get",
      params: {
        user: userdata.role === "dealer" ? userdata : "", // conditional user param
      },
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      url: Constants.url + "orders/orders-summary",
    }).then((res) => {
      return res.data.data;
    });
  };

  const {
    refetch,
    data: Ordersdata,
    isLoading,
  } = useQuery({
    queryFn: () => OrdersApi(),
    queryKey: ["ordersdata"],
    staleTime: Infinity,
    cacheTime: 1000 * 60 * 60,
  });

  return (
    <>
      {!isLoading && !loader ? (
        <div className="dashboardWrp" id="pageId">
          <div className="uk-container uk-container-expand">
            <div className="dashboardTop">
              <div uk-grid="" className="uk-grid">
                <div className="uk-width-1-1">
                  <div className="uk-margin ">
                    <div className="uk-left ">
                      <div>
                        <h2>Orders</h2>
                      </div>
                    </div>
                  </div>

                  <div className="analyticsContainer formCentralContainer">
                    <ul
                      className="uk-subnav uk-subnav-pill  OrdersTabs "
                      uk-switcher="connect: #analyticsTabs"
                    >
                      {Ordersdata.ordersSummary.map((item, index) => (
                        <li key={index}>
                          {" "}
                          {userdata.role === "dealer" &&
                          item.summaryType === "incart" ? (
                            ""
                          ) : (
                            <a>
                              {item.summaryType === "pending-dealership" ? "pending-Bank" : item.summaryType }{" "}
                              <h6 className="uk-text-center">
                                {" "}
                                {userdata.role != "viewer" ? item.count : '' }
                              </h6>{" "}
                            </a>
                          )}{" "}
                        </li>
                      ))}
                    </ul>


                    <div className="tabContent">
                      <ul className="uk-switcher " id="analyticsTabs">
                        {Ordersdata.ordersSummary.map((item, index) => (
                          <li key={index}>
                            {userdata.role === "dealer" &&
                            item.summaryType === "incart" ? (
                              ""
                            ) : (
                              <OrdersTAb key={index} Apiendpoint={item.summaryType} summaryrefetch = {refetch} />
                            )}
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <SplashScreen />
      )}
    </>
  );
};

export default Orders;
